document.addEventListener("DOMContentLoaded", function () {
  const burgerMenu = document.getElementById('burgerMenu');
  const mainNav = document.getElementById('mainNav');
  const navDropdownLinks = document.querySelectorAll('.nav-dropdown > a');
  const searchWrapper = document.getElementById("searchWrapper");
  const searchInput = document.getElementById("search-input");
  const searchExecute = document.getElementById("searchExecute");
  // burgerMenu and mainNav
  if (burgerMenu && mainNav) {
    burgerMenu.addEventListener('click', () => {
      const isActive = burgerMenu.classList.toggle('active');
      mainNav.classList.toggle('active');

      if (!isActive) {
        document.querySelectorAll('.nav-dropdown.open').forEach(drop => drop.classList.remove('open'));
      }
    });
  }
  // Dropdown open/close - only on devices without hover (touch devices)
  navDropdownLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
        e.preventDefault();
        const parent = this.closest('.nav-dropdown');
        if (!parent) return;
        const isOpen = parent.classList.contains('open');
        document.querySelectorAll('.nav-dropdown.open').forEach(drop => drop.classList.remove('open'));
        if (!isOpen) {
          parent.classList.add('open');
        }
      }
    });
  });
  // Close dropdowns when clicking outside navDropdown or burgerMenu
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.nav-dropdown') && !e.target.closest('#burgerMenu')) {
      document.querySelectorAll('.nav-dropdown.open').forEach(drop => drop.classList.remove('open'));
    }
  });
  // Search toggle logic
  if (searchExecute && searchWrapper && searchInput) {
    searchExecute.addEventListener("click", function (event) {
      event.stopPropagation();
      searchWrapper.classList.toggle("active");
      if (searchWrapper.classList.contains("active")) {
        searchInput.focus();
      }
    });
    document.addEventListener("click", function (event) {
      if (!searchWrapper.contains(event.target)) {
        searchWrapper.classList.remove("active");
      }
    });
  }
  // Carousel des avis
  if (typeof jQuery !== "undefined" && jQuery('.carousel-content').length) {
    jQuery('.carousel-content').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            speed: 2000,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 3,
            speed: 3000,
          }
        }
      ]
    });
  }
  // Top banner dismiss button
  const topBanner = document.querySelector(".top-banner");
  const removeBanner = document.querySelector(".remove-btn");
  if (topBanner && removeBanner) {
    removeBanner.addEventListener("click", () => {
      topBanner.classList.add("hide");
    });
  }
  // Scroll progress bar
  const progressBar = document.getElementById("progress-bar");
  const isDesktop = window.matchMedia("(min-width: 768px)").matches;
  if (isDesktop && progressBar) {
    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      progressBar.style.width = `${scrolled}%`;
    });
  }


});

// Jquery
require('webpack-jquery-ui/autocomplete')
$(document).ready( function() {
  // Search suggestions
  const searchInput = $('#search-input');
  const suggestionContainer = $('#searchResults');

  searchInput.on('input', function() {
    const query = searchInput.val().trim();
    if (query.length >= 2) {
      fetch($('form#search').attr('action') + '?term=' + query, {
        method: "GET",
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          "Accept": "application/json",
        },
      })
          .then(response => response.json())
          .then(data => {
            const suggestionsHtml = "<ul>" + data.map(item => {
              return `<li><a href="${item.url}">
                                <span>${item.label}
                                    ${ item.voters_count ? `<small> ${item.voters_count}  ${item.voters}</small>` : `` }
                                </span>
                                <i data-star="${item.note}"></i>
                            </a></li>`;
            }).join('') + "</ul>";
            suggestionContainer.find('ul').remove(); // remove any existing ul element
            suggestionContainer.find('.ajoutermarque').before(suggestionsHtml);
            suggestionContainer.css('display', 'block');
          })
    } else {
      suggestionContainer.css('display', 'none');
    }
  });

  suggestionContainer.on('click', 'li', function() {
    const suggestionText = $(this).find('span').html().replace(/<small>(.*?)<\/small>/g, '');
    searchInput.val(suggestionText.trim());
    suggestionContainer.css('display', 'none');
  });

  $(document).on('click', function(event) {
    if (!searchInput.is(event.target) && !suggestionContainer.is(event.target) && suggestionContainer.has(event.target).length === 0) {
      suggestionContainer.css('display', 'none');
    }
  });
});
